import React from 'react';

// ERAK Business Suite brand mark.
// Single horizontal lockup: official logo tile + product wordmark, vertically
// centered. Text inherits color so it adapts on dark sidebars and the navy
// login panel. The wordmark stays on one line; font size steps down per size
// so it never wraps awkwardly.
export function BrandMark({ size = 'md', showText = true, className = '' }) {
  const sizes = {
    sm: { box: 'h-9 w-9', label: 'text-sm' },
    md: { box: 'h-10 w-10', label: 'text-sm' },
    lg: { box: 'h-14 w-14', label: 'text-2xl' },
  }[size];

  return (
    <div className={`flex items-center gap-2.5 ${className}`} data-testid="brand-mark">
      <img
        src="/erak-logo.jpeg"
        alt="ERAK Group"
        width="56"
        height="56"
        className={`${sizes.box} aspect-square shrink-0 rounded-xl object-cover ring-1 ring-black/10 shadow-sm`}
      />
      {showText && (
        <div className={`font-display font-bold leading-none whitespace-nowrap ${sizes.label}`}>
          ERAK Business Suite
        </div>
      )}
    </div>
  );
}
